import api from '@/api'
import Vue from 'vue';
import permissions from '@/api/permissions'
import _ from 'lodash'

export default {
  state: {
    news: {
      filter: {},
      total: undefined,
      data: [],
      items: {}
    },
    fixedNews: {
      items: []
    }
  },

  getters: {
    news: s => s.news,
    fixedNews: s => s.fixedNews,
    newsItem: s => id => s.news.items[id]
  },

  mutations: {
    clearNews(s) {
      s.news = {
        filter: {},
        total: undefined,
        data: [],
        items: {},
      };
    },

    setNews(s, payload) {
      s.news.filter = payload.filter;
      s.news.total = payload.data.total;
      s.news.data = payload.data.news.map(e => ({
        id: e.id,
        title: e.title,
        briefDescription: e.shortBody,
        content: e.body1,
        publicationDate: new Date(e.time),
        from: api.Date.fromAPI(e.dtFrom),
        to: api.Date.fromAPI(e.dtTo)
      }));
    },

    setNewsItem(s, payload) {
      const items = {};

      items[payload.id] = {
        id: payload.id,
        title: payload.title,
        from: api.Date.fromAPI(payload.dtFrom),
        to: api.Date.fromAPI(payload.dtTo),
        briefDescription: payload.shortBody,
        content: payload.body1,
        publicationDate: new Date(payload.time),
        archived: payload.state === 'Archived'
      };

      s.news.items = items;
    },

    setFixedNews(s, payload) {
      s.fixedNews.items = payload.data.news.map(e => ({
        id: e.id,
        title: e.title,
        briefDescription: e.shortBody,
        content: e.body1,
        publicationDate: new Date(e.time),
        from: api.Date.fromAPI(e.dtFrom),
        to: api.Date.fromAPI(e.dtTo)
      }));
    }
  },

  actions: {
    async fetchNews({commit}, { page, pageSize, archive }) {
      let error;

      try {
        const filters = {
          page: page || 1,
          pageSize: pageSize || 10,
          state: archive ? 'Archived' : 'Active'
        };

        commit('clearNews');

        const response = await api.get('/news', {
          params: filters
        });
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('setNews', {
            filter: filters,
            data: result
          });
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async fetchFixedNews({commit}) {
      let error;

      try {
        const response = await api.get('/news/fixed');
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('setFixedNews', {
            data: result
          });
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while fetching fixed news', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async postNews({dispatch, getters}, { title, briefDescription, content, from, to }) {
      let error;

      try {
        const response = await api.post(`/news`, {
          title: title,
          shortBody: briefDescription,
          body1: content,
          dtFrom: api.Date.toAPI(from),
          dtTo: api.Date.toAPI(to)
        });
        const { status, errorCode } = response.data;

        if (status === 200) {
          await dispatch('fetchNews', getters.news.filter);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async updateNews({dispatch, getters}, { id, title, briefDescription, content, fixed }) {
      let error;

      try {
        const response = await api.put(`/news/${id}`, {
          title: title,
          shortBody: briefDescription,
          body1: content,
          fixed
        });
        const { status, errorCode } = response.data;

        if (status === 200) {
          await dispatch('fetchNewsItem', { id });
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async fetchNewsItem({commit}, {id}) {
      let error;

      try {
        const response = await api.get(`/news/${id}`);
        const { status, result, errorCode } = response.data;

        if (status === 200) {
          commit('setNewsItem', result);
        }
        else {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    },

    async archiveNewsItem({}, {id}) {
      let error;

      try {
        const response = await api.put(`/news/${id}/archive`);
        const { status, errorCode } = response.data;

        if (status !== 200) {
          error = new api.Errors(errorCode);
        }
      }
      catch(e) {
        console.error('Something went wrong while saving organization data', e);
        error = e;
      }

      if (error) {
        throw error;
      }
    }
  }
}
